import React from 'react'

function WorkerPage() {
  return (
    <div>WorkerPage</div>
  )
}

export default WorkerPage